import { toast } from 'react-toastify';
import { sentenceCase } from 'change-case';

export const toastServerError = (e: any) => {
  console.dir(e);
  toast.error('Whoops! Something went wrong. Please refresh and try again.');
};

export const logServerError = (e: any) => console.dir(e);

interface ValidationError {
  message: string;
  path: string[];
}

export const toastValidationErrorsApollo = (
  errors: ValidationError[],
  keysToNotToast: string[] = []
) => {
  errors.forEach(error => {
    const key = error.path[1];
    if (!keysToNotToast.includes(key)) {
      const errorMessage =
        key === 'base'
          ? error.message
          : `${sentenceCase(key)} ${error.message}`;
      toast.error(errorMessage);
    }
  });
};
